import React from 'react';
import laroute from '@/shared/laroute';

export default class CookieAlertDom extends React.Component {
    render() {
        const privacyPolicyLink = laroute.route('user.privacypolicy.index') + '/';
        return (
            <div className="l-cookie-alert">
                <p className="l-cookie-alert__txt">
                    <span className="l-cookie-alert__title">Cookieの利用について</span>
                    当サイトはサービス向上のためCookieを利用しております。以降ページ遷移した場合は、Cookie利用に同意したことになります。
                    <a className="l-cookie-alert__link" href={privacyPolicyLink}>詳しくはこちら</a>
                </p>
                <span id="js-cookie_close" className="l-cookie-alert__close icon_close"></span>
            </div>
        )
    }
}
